import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  bottomSpacer: {
    marginBottom: 15,
  },
  paddingSpacer: {
    paddingTop: 30,
  },
  dialogAction: {
    padding: "0 24px 24px 24px",
  },
  actionButton: {
    marginLeft: "24px !important",
  },
  dialogHeader: {
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
  },
  error: {
    marginBottom: 8,
  },
  loader: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(255,255,255,0.7)",
    zIndex: 1400,
  },
}));
